import { computed } from 'vue';
import { useStore } from 'vuex';

export function getIsXichengBrand(brandState) {
    const brand = brandState?.publishBrand?.brand;
    console.log('brand', brand);
    return brand === 'xcjyyxw';
}

export function useIsXichengBrand() {
    const store = useStore();

    const isXichengBrand = computed(() => {
        return getIsXichengBrand(store.state.brand);
    });

    return {
        isXichengBrand,
    };
}
